<template>
  <v-container class="mt-2">
    <v-card
      class="px-2">
      <v-row>
        <v-col>
          <p>Coberturas - Novo Registro</p>
        </v-col>
        <v-col cols="3" class="d-flex flex-row justify-end">
          <v-btn small @click="save">
            <v-icon small title="Create">fas fa-save</v-icon>
          </v-btn>
          <v-btn small @click="$refs.form.goBack()">
            <v-icon small title="Voltar">fas fa-arrow-circle-left</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-divider class="mb-4"></v-divider>

      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <CoverageForm ref="form" :typeForm="'new'" :errors="errors" :coverage="coverage"></CoverageForm>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { mapErrors } from "@/common/validation";
import { mapActions, mapMutations } from "vuex";
import CoverageForm from "@/components/coverage/coverage_form"

export default {
  components: { CoverageForm },
  data() {
    return {
      errors: {},
      coverage: {
        name: null,
        recordType: null,
        is_ans_coverage: null,
        is_executive_differential: null,
        description: null,
      },
    };
  },
  methods: {
    ...mapActions("coverage", ["createCoverage"]),
    ...mapMutations(["toogleDialogLoading", 'showmsg']),
    save() {
      if(!this.$refs.form.validate()) {
        this.showmsg({text: 'Por favor, preencha os campos obrigatórios.', type: 'warning'});
        return;
      }
      
      this.toogleDialogLoading(true);
      this.errors = {}
      const formModel = this.$refs.form.model()

      let payload = { ...formModel };
      payload.record_type_id = {
        id: formModel.recordTypeId,
      };

      payload.coverage_description_id = {
        id: formModel.descriptionId,
      };

      payload.coverage_group_id = {
        id: formModel.groupId,
      };

      this.createCoverage(payload).then(data => {
        this.$router.push(`/coverage/${data}/show`)
      }).catch((error) => {
        const { errors } = error.response.data;
        this.errors = mapErrors(payload, errors)
      }).finally(() => {
        this.toogleDialogLoading(false);
      });
    }
  },
};
</script>


